
import {format, parseISO, formatISO} from "date-fns";
import Papaparse from "papaparse";

import ServiceDataResponse from "../models/ServiceDataResponse";
import CardUtils from "../pages/Observation/Components/Models/CardUtils";




function findCategory(schema, id)
{
    var result = schema.categories.find((c) => c.id.toLowerCase() === id.toLowerCase());
    return result;
}

function findGroup(categoryNd, id)
{
    var result = categoryNd.groups.find((g) => g.id.toLowerCase() == id.toLowerCase());
    return result;
}

function findGlobalGradeGroup(schema, id)
{
    var result = schema.scoring.globalGroupMultipliers.find((ggm) => CardUtils.titleToId(ggm.title).toLowerCase() === CardUtils.titleToId(id.toLowerCase()));
    return result; 
}

function findCard(groupNd, id)
{
    var result = groupNd.cards.find((c) => c.id.toLowerCase() == id.toLowerCase());
    return result;
}

function toFieldTypeValue(val, newFieldType)
{
    // we cannot handle arrays right now, so check that first
    if (Array.isArray(val)) return val;
    var fieldType = newFieldType.toLowerCase();
    if ((!fieldType) || (fieldType=== "text") || (fieldType === "string") || (fieldType === "dropdown"))
    {
        return val.toString();
    }
    else if (fieldType == "intorfloat")
    {
        // this will evaluate and figure OUT if it's an int or float and return that
        var interimVal = parseFloat(val);
        if (Number.isNaN(interimVal)) return 0;
        var result =  (Number.isInteger(interimVal)) ? parseInt(val) : parseFloat(val); // tbd: no checking for nulls, infinity or isNaN
        return result;

    }
    else if ((fieldType === "int") || (fieldType === "integer"))
    {
        return parseInt(val);
    }
    else if (fieldType === "float")
    {
        return parseFloat(val);
    }
    else if ((card.display?.type) && (card.display?.type === "datetime"))
    {
        return parseISO(val);
    }
    else 
    {
        return val;
    }
}

function excludeFromTransform(schemaNode)
{
    var result = (schemaNode.dataApi?.exclude);
    return result;
}

function getDefaultFieldTypeValue(card)
{
    var fieldType = (card.fieldType) ? card.fieldType.toLowerCase() : "text"; 
    if ((fieldType === "multiinput") || (fieldType === "multientrykeypair"))
    {
        return [];
    }
    else if ((!fieldType) || (fieldType=== "text") || (fieldType === "string") || (fieldType === "dropdown"))
    {
        return "";
    }
    else if ((fieldType === "int") || (fieldType === "integer") || (fieldType === "float"))
    {
        return 0;
    }
    else if ((card.display?.type) && (card.display?.type === "datetime"))
    {
        return parseISO("1901-01-01T00:00:00Z");
    }

    else // what about things that should be integers?
    {
        return "";
    }
}

function getValue(card, raw)
{

    var val = (raw.data.Raw[card.id]) ? raw.data.Raw[card.id] : getDefaultFieldTypeValue(card);
    return val;
}

function getRawValue(propId, raw, defaultFieldTypeValueOverride)
{

    var val = raw.data.Raw[propId];
    var result = (defaultFieldTypeValueOverride) ? toFieldTypeValue(val, defaultFieldTypeValueOverride) : val;
    return result;
}


export default class DataTransformManager
{

    static transformGradedObservations(rawList, schemaId, schema, isFlat = false)
    {
        var result = [];
        var fact = [];
        for (let rawRec of rawList)
        {
            var interimResponse = this.transformGradedObservation(rawRec, schema, isFlat);
            if (interimResponse.hasError)
            {
                return new ServiceDataResponse(fact, true, interimResponse.messages);
                break;
            }
            fact.push(interimResponse.data);
        }
        if (isFlat)
        {
            result.push({type: schemaId.toLowerCase() + "-flat", starType: "fact", tableType: "ObservationFlatFact", data: fact});
        }
        else
        {
            result.push({type: schemaId.toLowerCase() + "-hierarchical", starType: "fact", tableType: "ObservationHierarchyFact", data: fact});
        }
        return new ServiceDataResponse(result, false, "Complete");
    }

    static transformGradedObservation(raw, schema, isFlat)
    {
        var result = {
            id: raw.identifiers.id,
            originalId: raw.originalId,
            factKey: "",
            status: raw.identifiers.status,
            schema: raw.data.schema.id,
            schemaVersion: raw.data.schema.schemaVersion,
            scorer: raw.score.Score.Scorer.id,
            scorerVersion: raw.score.Score.Scorer.version,
            scoreReason: raw.score.Score.ScoreReason,
            totalInspected: raw.score.Score.totalInspected,
            weightedGrade: raw.score.Score.Grade.Weighted,
            rawGrade: raw.score.Score.Grade.Raw,
            weightedScore: raw.score.Score.Grade.WeightedScore,
            rawScore: raw.score.Score.Grade.RawScore,
            isRejected: raw.score.Score.isRejected,
            isPreInspectRejected: raw.score.Score.isPreInspectRejected
        };
        // UnderInspection - note we do NOT transform arrays of data
        var ouiNd = findCategory(schema, "oui");
        if (!ouiNd) return new ServiceDataResponse(null, true, "Unable to find oui category in schema.");
        // for EACH group, get all properties. We don't care about the group itself, only the properties. 
        ouiNd.groups.forEach((group) =>{
            // we may be ignoring the group by marking it with the dataExport.exclude = true flag
            if (!excludeFromTransform(group))
            {
                group.cards.forEach((card) => {
                    if (!excludeFromTransform(card))
                    {
                        result[card.id] = getValue(card, raw);
                    }
                });
            }
        });

        // Notes -
        var notesNd = findCategory(schema, "notes");
        if (!notesNd) return new ServiceDataResponse(null, true, "Unable to find Notes category in schema.");
        notesNd.groups.forEach((group) =>{
            if (!excludeFromTransform(group))
            {
                group.cards.forEach((card) =>{
                if (!excludeFromTransform(card))
                  {
                     result[card.id] = getValue(card, raw);
                  }
              });
            }
        });


        // pre-inspect reject - TBD

        // defects
        var defectsNd = findCategory(schema, "defects");
        if (!defectsNd) return new ServiceDataResponse(null, true, "Unable to find Defects category in schema.");
        // total count is a special defects group. We want to evaluate it separately and NOT include it when we do defect groups
        // TBD - need better error handling!
        var totalCountNd = findGroup(defectsNd, "totalcount");
        if (!totalCountNd) return new ServiceDataResponse(null, true, "Unable to find Total Count group in schema.");
        // this is a special case where we do indirection - we let the customer choose the names of these fields but we keep the ids to ourselves. 
        // But remember that the values are stored in the "compressed format"
        var totalCountCard = findCard(totalCountNd, "qtyinspected");
        result[CardUtils.titleToId(totalCountCard.containerCountTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.containerCountTitle), raw, "intOrFloat"); // do we allow floats? Should we check the value 
        result[CardUtils.titleToId(totalCountCard.containerQtyTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.containerQtyTitle), raw, "intOrFloat"); 
        result[CardUtils.titleToId(totalCountCard.unitQtyTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.unitQtyTitle), raw, "intOrFloat");

        if (!isFlat) result.defects = {};
        // defect groups. We are going to put defects UNDER their defect groups so that it's obvious what they fall under. I cannot think of a use for analysis ONLY
        // of a specific defect group, but you COULD do that with this structure. Otherwise you really do need star schema with each defect blown out.
        defectsNd.groups.forEach((group) => {
            if (!excludeFromTransform(group)) // make sure to EXCLUDE totalCount group so it doesn't get processed!
            //if (group.id.toLowerCase !== "totalCount") // skip it. Special case. It really should be in its own category?
            {
                var defectGroupResult = {};
                var groupId = (group.id) ? group.id : CardUtils.titleToId(group.groupTitle);
                // some of these groups are actually affecting the grade. Some are NOT. We use the multiplier to determine, which means
                // EACH group that contributes to the score must have a global multiplier
                var globalGradeGroupSchema = findGlobalGradeGroup(schema, groupId);
                var isGradeGroup = (globalGradeGroupSchema);
                defectGroupResult.defects = {};
                var groupTotalDefects = 0;
                group.cards.forEach((card) => {
                    var val = getRawValue(card.id, raw, "intOrFloat");
                    groupTotalDefects = groupTotalDefects + val; // we're going to include it in the total, even if we don't show the card. Not sure why we wouldn't show it but there you go.
                    if (!excludeFromTransform(card))
                    {
                        if (isFlat)
                        {
                            result[groupId + "." + card.id] = val;
                        }
                        else 
                        {
                            defectGroupResult.defects[card.id] = val;
                        }
                    }
                });
                if (isGradeGroup)
                {
                    if (isFlat)
                    {
                        result[groupId + "." + "totalDefects"] = groupTotalDefects;
                        result[groupId + "." + "weightedMultiplier"] = (isGradeGroup) ? globalGradeGroupSchema.multiplier : 0; // if this is NOT a grade group, then set the multiplier to 0 so we know it doesnt get included in scoring

                    }
                    else 
                    {
                        defectGroupResult.totalDefects = groupTotalDefects;
                        defectGroupResult.weightedMultiplier = (isGradeGroup) ? globalGradeGroupSchema.multiplier : 0; // if this is NOT a grade group, then set the multiplier to 0 so we know it doesnt get included in scoring

                    }
                }

                // finally, add the whole group
                if (!isFlat)
                {
                    result.defects[groupId] = defectGroupResult;
                }
            }
        });

        return new ServiceDataResponse(result, false, "Ok");

    }



    // Star Dimensions only
    static transformStarGradedDimensions(schemaId, schema)
    {
        var result = [];
        var interimDefectCategoryResponse = this.transformDefectCategoriesStar(schema);
        if (interimDefectCategoryResponse.hasError)
        {
            return new ServiceDataResponse(null, true, interimDefectCategoryResponse.messages);
        }
        result.push({type: schemaId.toLowerCase() + "-category-dim-data", starType: "dimension", schemaId: schemaId, dimLevel: "category", data: interimDefectCategoryResponse.data});

        var interimDefectResponse = this.transformDefectsStar(schema);
        if (interimDefectCategoryResponse.hasError)
        {
            return new ServiceDataResponse(null, true, interimDefectResponse.messages);
        }
        result.push({type: schemaId.toLowerCase() + "-defect-dim-data", starType: "dimension", schemaId: schemaId, dimLevel: "defect", data: interimDefectResponse.data});

        return new ServiceDataResponse(result, false, "Complete");
    }


    //




    // STAR TABLES

    //var result = {factMain: {}, factCategory: [], factDefect: []}
    static transformStarGradedObservations(rawList, schemaId, schema)
    {
        var result = [];

        var factMain = [];
        var factCategory = [];
        var factDefect = [];
        var factChildren = [];
        for (let rawRec of rawList)
        {
            var interimResponse = this.transformGradedObservationStar(rawRec, schema);
            if (interimResponse.hasError)
            {
                return new ServiceDataResponse(null, true, interimResponse.messages);
            }
            factMain.push(interimResponse.data.factMain);
            interimResponse.data.factCategory.forEach((cat) => {factCategory.push(cat)});
            interimResponse.data.factDefect.forEach((def) => {factDefect.push(def)});
            interimResponse.data.factChildren.forEach((def) => {factChildren.push(def)});
        }
        result.push({type: schemaId.toLowerCase() + "-fact-main", starType: "fact", tableType: "ObservationFact", data: factMain});
        result.push({type: schemaId.toLowerCase() + "-fact-category", starType: "fact", tableType: "ObservationCategoryFact", data: factCategory});
        result.push({type: schemaId.toLowerCase() + "-fact-defect", starType: "fact", tableType: "ObservationDefectFact", data: factDefect});
        result.push({type: schemaId.toLowerCase() + "-fact-children", starType: "childFact", tableType: "ObservationChildFact", data: factChildren});

        var interimDefectCategoryResponse = this.transformDefectCategoriesStar(schema);
        if (interimDefectCategoryResponse.hasError)
        {
            return new ServiceDataResponse(null, true, interimDefectCategoryResponse.messages);
        }
        result.push({type: schemaId.toLowerCase() + "-category-dim-data", starType: "dimension", tableType: "", data: interimDefectCategoryResponse.data});

        var interimDefectResponse = this.transformDefectsStar(schema);
        if (interimDefectCategoryResponse.hasError)
        {
            return new ServiceDataResponse(null, true, interimDefectResponse.messages);
        }
        result.push({type: schemaId.toLowerCase() + "-defect-dim-data", starType: "dimension", tableType: "", data: interimDefectResponse.data});

        return new ServiceDataResponse(result, false, "Complete");
    }


    static transformGradedObservationStar(raw, schema)
    {
        var result = {factMain: {}, factCategory: [], factDefect: [], factChildren: []}
        var rowId = raw.identifiers.id;
        result.factMain = {
            id: rowId,
            factKey: "", // for the main fact table we should only have a SINGLE record per observationId
            originalId: raw.originalId,
            status: raw.identifiers.status,
            schema: raw.data.schema.id,
            schemaVersion: raw.data.schema.schemaVersion,
            scorer: raw.score.Score.Scorer.id,
            scorerVersion: raw.score.Score.Scorer.version,
            scoreReason: raw.score.Score.ScoreReason,
            totalInspected: raw.score.Score.totalInspected,
            weightedGrade: raw.score.Score.Grade.Weighted,
            rawGrade: raw.score.Score.Grade.Raw,
            weightedScore: raw.score.Score.Grade.WeightedScore,
            rawScore: raw.score.Score.Grade.RawScore,
            isRejected: raw.score.Score.isRejected,
            isPreInspectRejected: raw.score.Score.isPreInspectRejected
        };
        // UnderInspection - note we do NOT transform arrays of data
        var ouiNd = findCategory(schema, "oui");
        if (!ouiNd) return new ServiceDataResponse(null, true, "Unable to find oui category in schema.");
        // for EACH group, get all properties. We don't care about the group itself, only the properties. 
        ouiNd.groups.forEach((group) =>{
            // we may be ignoring the group by marking it with the dataExport.exclude = true flag
            if (!excludeFromTransform(group))
            {
                group.cards.forEach((card) => {
                    if (!excludeFromTransform(card))
                    {
                        result.factMain[card.id] = getValue(card, raw);
                    }
                });
            }
        });

        // Notes -
        var notesNd = findCategory(schema, "notes");
        if (!notesNd) return new ServiceDataResponse(null, true, "Unable to find Notes category in schema.");
        notesNd.groups.forEach((group) =>{
            if (!excludeFromTransform(group))
            {
                group.cards.forEach((card) =>{
                if (!excludeFromTransform(card))
                  {
                     result.factMain[card.id] = getValue(card, raw);
                  }
              });
            }
        });

        // pre-inspect reject - TBD

        // defects
        var defectsNd = findCategory(schema, "defects");
        if (!defectsNd) return new ServiceDataResponse(null, true, "Unable to find Defects category in schema.");
        // total count is a special defects group. We want to evaluate it separately and NOT include it when we do defect groups
        // TBD - need better error handling!
        var totalCountNd = findGroup(defectsNd, "totalcount");
        if (!totalCountNd) return new ServiceDataResponse(null, true, "Unable to find Total Count group in schema.");
        // this is a special case where we do indirection - we let the customer choose the names of these fields but we keep the ids to ourselves. 
        // But remember that the values are stored in the "compressed format"
        var totalCountCard = findCard(totalCountNd, "qtyinspected");
        result.factMain[CardUtils.titleToId(totalCountCard.containerCountTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.containerCountTitle), raw, "intOrFloat"); // do we allow floats? Should we check the value 
        result.factMain[CardUtils.titleToId(totalCountCard.containerQtyTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.containerQtyTitle), raw, "intOrFloat"); 
        result.factMain[CardUtils.titleToId(totalCountCard.unitQtyTitle)] = getRawValue(CardUtils.titleToId(totalCountCard.unitQtyTitle), raw, "intOrFloat");

        // defect groups. We are going to put defects UNDER their defect groups so that it's obvious what they fall under. I cannot think of a use for analysis ONLY
        // of a specific defect group, but you COULD do that with this structure. Otherwise you really do need star schema with each defect blown out.
        defectsNd.groups.forEach((group) => {
            if (!excludeFromTransform(group)) // make sure to EXCLUDE totalCount group so it doesn't get processed!
            {
                var groupId = (group.id) ? group.id : CardUtils.titleToId(group.groupTitle);
                // some of these groups are actually affecting the grade. Some are NOT. We use the multiplier to determine, which means
                // EACH group that contributes to the score must have a global multiplier
                var globalGradeGroupSchema = findGlobalGradeGroup(schema, groupId);
                var isGradeGroup = (globalGradeGroupSchema);
                var groupTotalDefects = 0;
                group.cards.forEach((card) => {
                    var val = getRawValue(card.id, raw, "intOrFloat");
                    groupTotalDefects = groupTotalDefects + val; // we're going to include it in the total, even if we don't show the card. Not sure why we wouldn't show it but there you go.
                    if (!excludeFromTransform(card))
                    {
                        // factKey is part of the composite key that makes each BI row unique. Dimensional data like defects and categories will have the rowId in multiple times. This makes it unique. 
                        result.factDefect.push({id: rowId, categoryKey: groupId, defectKey: card.id, factKey: card.id, count: val})
                        //result[card.id] = val;
                    }
                });
                result.factCategory.push({id: rowId, categoryKey: groupId, factKey: groupId, count: groupTotalDefects});
                //result[groupId] = (isGradeGroup) ? groupTotalDefects: 0; // don't count total defects for groups we don't include in grading
            }
        });

        // get fact Children - these are one-to-many facts that have been identified as worth pushing into the ObservationChildFact table
        // assume any of these values are in the raw node
        if (schema.dataApi?.childProps)
        {
            schema.dataApi.childProps.forEach((childProp) =>
            {
                var val = getRawValue(childProp.id, raw, []);
                var factKey = val;
                if (Array.isArray(val)) // if it's an array, then each element of the array is broken out into a separate child value
                {
                        
                    if (val.length > 0)
                    {
                        val.forEach((el) =>
                        {
                            {
                                factKey = el; // assume it's an array with a single value
                                if (childProp.fieldType.toLowerCase() === "multientrykeypair") // special case where we have specific values in each array element
                                {
                                    factKey = el[childProp.factProp];
                                }
                            }
                            result.factChildren.push({id: rowId, categoryKey: childProp.factType, factKey: factKey, count: 1});    
                        });
                    }
                    else 
                    {
                        result.factChildren.push({id: rowId, categoryKey: factType, factKey: factKey, count: 1});
                    }
                }
            });
        }

        return new ServiceDataResponse(result, false, "Ok");

    }

    static transformDefectCategoriesStar(schema)
    {
        var defectsNd = findCategory(schema, "defects");
        if (!defectsNd) return new ServiceDataResponse(null, true, "Unable to find Defects category in schema.");
        var result = [];

        var defectsNd = findCategory(schema, "defects");
        // defect groups. We are going to put defects UNDER their defect groups so that it's obvious what they fall under. I cannot think of a use for analysis ONLY
        // of a specific defect group, but you COULD do that with this structure. Otherwise you really do need star schema with each defect blown out.
        defectsNd.groups.forEach((group) => {
            if (!excludeFromTransform(group)) 
            //if (group.id.toLowerCase !== "totalCount") // skip it. Special case. It really should be in its own category?
            {
                var groupId = (group.id) ? group.id : CardUtils.titleToId(group.groupTitle);
                // some of these groups are actually affecting the grade. Some are NOT. We use the multiplier to determine, which means
                // EACH group that contributes to the score must have a global multiplier
                var globalGradeGroupSchema = findGlobalGradeGroup(schema, groupId);
                var isGradeGroup = (globalGradeGroupSchema);
                var weightedMultiplier = (isGradeGroup) ? globalGradeGroupSchema.multiplier : 0; // if this is NOT a grade group, then set the multiplier to 0 so we know it doesnt get included in scoring
                result.push({dimKey: groupId, title: (group.title) ? group.title : groupId, multiplier: weightedMultiplier});
            }
        });
        return new ServiceDataResponse(result, false, "Ok");
    }


    // assumes that the "key" of each defect is the defect id
    static transformDefectsStar(schema)
    {
        var defectsNd = findCategory(schema, "defects");
        if (!defectsNd) return new ServiceDataResponse(null, true, "Unable to find Defects category in schema.");
        var result = [];

        var defectsNd = 
        // defect groups. We are going to put defects UNDER their defect groups so that it's obvious what they fall under. I cannot think of a use for analysis ONLY
        // of a specific defect group, but you COULD do that with this structure. Otherwise you really do need star schema with each defect blown out.
        defectsNd.groups.forEach((group) => {
            if (!excludeFromTransform(group)) 
            //if (group.id.toLowerCase !== "totalCount") // skip it. Special case. It really should be in its own category?
            {
                var defectGroupResult = {};
                var groupId = (group.id) ? group.id : CardUtils.titleToId(group.groupTitle);
                // some of these groups are actually affecting the grade. Some are NOT. We use the multiplier to determine, which means
                // EACH group that contributes to the score must have a global multiplier
                var globalGradeGroupSchema = findGlobalGradeGroup(schema, groupId);
                var isGradeGroup = (globalGradeGroupSchema);
                var weightedMultiplier = (isGradeGroup) ? globalGradeGroupSchema.multiplier : 0; // if this is NOT a grade group, then set the multiplier to 0 so we know it doesnt get included in scoring
                var groupTotalDefects = 0;
                group.cards.forEach((card) => {
                    if (!excludeFromTransform(card))
                    {
                        var defectKey = (card.id) ? card.id : CardUtils.titleToId(card.title);
                        result.push({dimKey: defectKey,  title: card.title, multiplier: weightedMultiplier, parentKey: groupId})
                    }
                });
            }
        });
        return new ServiceDataResponse(result, false, "Ok");

    }


   



}


